import React from "react";
import PropTypes from "prop-types";
import "./TableErrorMessage.style.scss";

const TableErrorMessage = (props) => {
  let list = props.list.filter((el) => el);
  return (
    <div className="table_error_message">
      {list.map((msg, i) => (
        <span key={i}>{msg}</span>
      ))}
    </div>
  );
};

TableErrorMessage.prototype = {
  list: PropTypes.array,
};
export default TableErrorMessage;



// WEBPACK FOOTER //
// ./src/components/common/errorBoundary/tableErrorMessage/TableErrorMessage.jsx